import StringField from './String/index.vue';
import ImageField from './Image/index.vue';
import ObjectField from './Object/index.vue';
import BoolField from './Bool/index.vue';
import EnumField from './Enum/index.vue';
import DateTimeField from './DateTime/index.vue';
import GUIDField from './GUID/index.vue';
import RoleField from './Role/index.vue';
import IntField from './Int/index.vue';
import BooleanField from './Boolean/index.vue';
import ArrayField from './Array/index.vue';
import FileField from './File/index.vue';
import MobileField from './Mobile/index.vue';
import DateField from './Date/index.vue';
import HtmlField from './Html/index.vue'
export default { 
    Name: "Element v4",
    Value: [
        { Type: "String", Name: "String", Theme:"Element", Component: StringField },
        { Type: "Image", Name: "Image", Theme:"Element", Component: ImageField },
        { Type: "Object", Name: "Object", Theme:"Element", Component: ObjectField },
        { Type: "Bool", Name: "Bool", Theme:"Element", Component: BoolField },
        { Type: "Enum", Name: "Enum", Theme:"Element", Component: EnumField },
        { Type: "DateTime", Name: "DateTime", Theme:"Element", Component: DateTimeField },
        { Type: "GUID", Name: "GUID", Theme:"Element", Component: GUIDField },
        { Type: "Role", Name: "Role", Theme:"Element", Component: RoleField },
        { Type: "Int", Name: "Int", Theme:"Element", Component: IntField },
        { Type: "Boolean", Name: "Boolean", Theme:"Element", Component: BooleanField },
        { Type: "Array", Name: "Array", Theme:"Element", Component: ArrayField },
        { Type: "File", Name: "File", Theme:"Element", Component: FileField },
        { Type: "Mobile", Name: "Mobile", Theme:"Element", Component: MobileField },
        { Type: "Date", Name: "Date", Theme:"Element", Component: DateField },
        { Type: "Html", Name: "Html", Theme:"Element", Component: HtmlField }
    ]
}